import axios from "axios";

// Base URL for your API
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

/**
 * Create Chat Availability
 */
export const createChatAvailability = async (payload) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/chat-availability`,
            payload
        );

        return response.data;
    } catch (error) {
        console.error("Error creating chat availability:", error);
        throw error;
    }
};


/**
 * List Chat Availability By App Name
 */
export const listChatAvailabilityByAppName = async (appName) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/chat-availability`,
            {
                params: {
                    app_name: appName
                }
            }
        );

        return response.data; // array of chat availability
    } catch (error) {
        console.error("Error fetching chat availability:", error);
        throw error;
    }
};

export const updateChatAvailabilityStatus = async (
    counsellorId,
    appName,
    status
) => {
    try {
        const response = await axios.patch(
            `${API_BASE_URL}/chat-availability/status`,
            {
                counsellor_id: counsellorId,
                app_name: appName,
                status: status,
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error updating chat availability status:", error);
        throw error;
    }
};